import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Draggable from 'react-draggable';
import './DraggableModal.scss';

const DraggableModal = props => {
  const { title, isOpen, body, handleClose, defaultPosition, onDrag } = props;

  return (
    <div>
      <Modal
        isOpen={isOpen}
        className='custom-modal'
        contentClassName='border-0 custom-modal-wraper'
        backdropClassName='toolbar-t-backdrop'
        centered
        toggle={handleClose}
      >
        <Draggable
          //   position={modalPosition}
          defaultPosition={defaultPosition}
          cancel='.undraggable'
          onDrag={onDrag}
        >
          <ModalBody className='rounded-0'>
            <ModalHeader
              className='header'
              toggle={handleClose}
              close={
                <button
                  type='button'
                  aria-label='close'
                  className='close'
                  onClick={handleClose}
                />
              }
            >
              {title}
            </ModalHeader>

            <div className='custom-modal-body'>{body}</div>
          </ModalBody>
        </Draggable>
      </Modal>
    </div>
  );
};

export default DraggableModal;
